import script from "./CopyrightData.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CopyrightData.vue?vue&type=script&lang=js"
export * from "./CopyrightData.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CopyrightData.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__